import * as yup from "yup";

export interface LessonTopicPageSnippetModel {
    SnippetID: number;
}

export const LessonTopicPageSnippetModelValidationRules = {
    SnippetID: yup.number().required(),
};
